/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import { CompanyContext } from '@/providers/CompanyContext'

const useCompany = () => {
  const companies = React.useContext(CompanyContext)
  return companies
}
export default useCompany
